module.exports = __webpack_public_path__ + "bin/27003141b04d34494ab3979ab9905cda.jpg";